// export const service = 'http://localhost:51456';
// export const service = 'http://showcaseservice.coruscant.republica.local:5000/';

export const service = process.env.REACT_APP_API_URL;
export const identityService = process.env.REACT_APP_SERVICE_IDENTITY;